import type { Iteration } from '@gonfalon/experiments/types';
import type { Variation } from '@gonfalon/flags/types';

export function variationLabel(v: Variation): string {
  if (v.name) {
    return v.name;
  }
  if (typeof v.value === 'object') {
    return JSON.stringify(v.value);
  }
  return String(v.value);
}

// until we support multiple flags per iteration each iteration will only have a single flag
// this function helps you get the one flag key from your iteration
export function singleFlagKey(iteration: Iteration | undefined) {
  if (!iteration?.flags) {
    return undefined;
  }
  const [flagKey] = Object.keys(iteration.flags);
  return flagKey;
}
